define('components/asset-player/views/player',[
    'components/asset-player/collections/assets',
    'components/asset-player/radio-channel',
    'components/asset-player/views/assets/asset-views'
], function (assets, channel, AssetViews) {
    "use strict";

    var PlayerView = Mn.ItemView.extend({
        "el": "body",

        "_isCCed": false,

        "_isMuted": false,

        "_isMuteSupported": false,

        "template": false,

        "initialize": function () {
            this._isMuteSupported = $('<audio>').prop('muted', true).prop('muted');

            this.initRadioComm();
        },

        "initRadioComm": function () {
            channel.comply(channel.Event.RENDER, this.renderAssets, this)
                    .comply(channel.Event.Mute.TOGGLE, this.toggleMute, this)
                    .comply(channel.Event.Transcript.TOGGLE, this.toggleTranscript, this)

                    .reply(channel.Event.Transcript.GET, this.isCCed, this)
                    .reply(channel.Event.Mute.GET, this.isMuted, this)
                    .reply(channel.Event.Mute.SUPPORTED, this.isMuteSupported, this);
        },

        "isCCed": function () {
            return this._isCCed;
        },

        "isMuted": function () {
            return this._isMuted;
        },

        "isMuteSupported": function () {
            return this._isMuteSupported;
        },

        "toggleMute": function (mute) {
            var $assets;

            if (!this.isMuteSupported()) {
                // Mute isn't supported on this browser
                return;
            }

            mute = mute === void 0 ? !this._isMuted : !!mute;

            this._isMuted = mute;

            $assets = $('.player-asset.player-loaded audio, .player-asset.player-loaded video, .cmrp-asset.player-loaded audio, .cmrp-asset.player-loaded video');
            
            if (mute) {
                $assets.attr('muted', '');
            } else {
                $assets.removeAttr('muted');
            }

            $assets.prop('muted', mute);

            channel.trigger(channel.Event.Mute.CHANGE, mute);
        },

        "toggleTranscript": function (cc) {
            var $assets;

            cc = cc === void 0 ? !this._isCCed : !!cc;

            this._isCCed = cc;

            $assets = $('.player-asset.player-loaded audio, .player-asset.player-loaded video, .cmrp-asset.player-loaded audio, .cmrp-asset.player-loaded video').has("track");
            
            $.each($assets,function (assetIdx, asset) {
                $(asset).prop('textTracks')[0].mode = "hidden";
                $('.video-active-controls').removeClass("dim-controls");
                if(cc) {
                    $(asset).prop('textTracks')[0].mode = "showing";
                    $('.video-active-controls').addClass("dim-controls");
                }
            });

            channel.trigger(channel.Event.Transcript.CHANGE, cc);
        },

        "mute": function () {
            this.toggleMute(true);
        },

        "unmute": function () {
            this.toggleMute(false);
        },

        "cc": function () {
            this.toggleTranscript(true);
        },

        "ccoff": function () {
            this.toggleTranscript(false);
        },

        "renderAssets": function (opts) {
            var selectors = '.player-asset:not(.player-loaded),.cmrp-asset:not(.player-loaded)',
                assetsToRetrieve = [],
                $playerAssets,
                $target,
                retValue,
                renderAsset;

            opts = opts || {};

            $target = $(opts.target || this.$el);

            $playerAssets = $target.filter(selectors) // If target itself is an asset
                                   .add($target.find(selectors)); // For all child assets within the target

            $playerAssets.each(function (index, elem) {
                var $elem = $(elem),
                    guid = $elem.data('guid') || '';

                if (!guid) {
                    return;
                }

                assetsToRetrieve.push({
                    "guid": guid,
                    "typeGuid": $elem.data('type-guid') || null
                });
            });

            renderAsset = function (asset) {
                var $assets,
                    AssetView,
                    childView;

                $assets = $playerAssets.filter(function () {
                    var guid = $(this).data('guid') || '';
                    return guid.toLowerCase() === asset.get('guid');
                });

                AssetView = asset.isAudio() && AssetViews.Audio
                            || asset.isImage() && AssetViews.Image
                            || asset.isVideo() && AssetViews.Video
                            || null;

                if (!AssetView) {
                    return;
                }

                childView = new AssetView({
                    "el": $assets,
                    "model": asset
                });

                childView.render();

                $assets.addClass('player-loaded');
            };

            retValue = assets.retrieveAssets(assetsToRetrieve);

            _.each(retValue.assets.cached, renderAsset, this);

            retValue.promise
                    .done(function (assetsChunk) {
                        _.each(assetsChunk.fresh, renderAsset, this);
                    });
        }
    });

    return new PlayerView();
});

